import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import ContactBoxes from '../components/ContactBoxes';
import DenmarkMap from '../components/DenmarkMap';
import { COMPANY_INFO, SERVICES_LIST } from '../data/mockData';

export default function Home() {
  return (
    <div className="space-y-16 md:space-y-24 pb-16">
      <SEO 
        title="Ventilationsanlæg til Erhverv & Service til Industrien →"
        description="Ventilationsanlæg til erhverv og industri ✓ K-TO Multiservice udfører services inden for indeklima ✓ 25 års erfaring ✆ Ring 22 72 87 23"
        slug="/"
        image="https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-8-1024x683.jpg"
        exact
      />

      {/* Hero Section */}
      <section className="relative bg-slate-950 text-white overflow-hidden pt-12 pb-20 md:pt-20 md:pb-28 border-b border-slate-800">
        {/* Hero Background Image with Gradient Overlay */}
        <div className="absolute inset-0 z-0 opacity-65 md:opacity-75">
          <img 
            src="https://assets.auxodev.dk/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-8-1024x683.jpg" 
            alt="Ventilationsanlæg og teknikrum" 
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/75 via-slate-950/50 to-slate-900/25"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            <div className="lg:col-span-12 max-w-4xl space-y-6">
              <h1 className="text-3xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight leading-[1.15]">
                Professionel ventilationsteknik til erhverv og industri
              </h1>

              <p className="text-slate-300 text-base sm:text-xl font-normal leading-relaxed max-w-3xl">
                K-TO Ventilationsteknik udfører service, indregulering, fejlfinding, reparation, salg, montering og rensning af ventilationsanlæg på hele Fyn og i hele Jylland.
              </p>

              {/* CTAs */}
              <div className="flex flex-wrap items-center gap-4 pt-4">
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="bg-sky-600 hover:bg-sky-500 text-white px-7 py-4 rounded-xl font-extrabold text-sm uppercase tracking-wider transition-all duration-200 shadow-lg hover:shadow-sky-500/25 flex items-center gap-2.5 nowrap-contact"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring på 22 72 87 23</span>
                </a>

                <a
                  href={`mailto:${COMPANY_INFO.email}`}
                  className="bg-slate-800 hover:bg-slate-700 text-slate-100 border border-slate-700 px-6 py-4 rounded-xl font-bold text-sm transition-all duration-200 flex items-center gap-2 nowrap-contact"
                >
                  <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true"></i>
                  <span>Send en e-mail</span>
                </a>

                <Link
                  to="/ydelser/service-og-ventilation"
                  className="inline-flex items-center gap-2 text-sky-400 hover:text-sky-300 font-bold text-sm px-4 py-3 transition-colors group"
                >
                  <span>Se vores ydelser</span>
                  <i className="fa-solid fa-arrow-right text-xs group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                </Link>
              </div>

              {/* Quick trust metrics */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 pt-6 border-t border-slate-800 text-xs text-slate-400">
                <div>
                  <span className="block text-white font-extrabold text-lg">30 Års Erfaring</span>
                  <span>Specialiseret viden</span>
                </div>
                <div>
                  <span className="block text-white font-extrabold text-lg">Fyn & Jylland</span>
                  <span>Lokal dækning</span>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  <span className="block text-white font-extrabold text-lg">Erhverv & Industri</span>
                  <span>Komplette løsninger</span>
                </div>
              </div>
            </div>



          </div>
        </div>
      </section>

      {/* Interactive Contact Boxes */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10 md:-mt-16 relative z-20">
        <ContactBoxes />
      </section>

      {/* Scrape Verbatim Intro Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200/90 shadow-sm grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          
          <div className="lg:col-span-7 space-y-5">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-sky-100 text-sky-800 text-xs font-bold uppercase tracking-wider">
              <i className="fa-solid fa-building text-sky-600" aria-hidden="true"></i>
              <span>Om K-TO Ventilationsteknik</span>
            </div>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight">
              Ventilationsanlæg til erhverv og industri i Jylland & Fyn
            </h2>

            <div className="prose prose-slate max-w-none text-slate-700 text-base leading-relaxed space-y-4">
              <p className="font-semibold text-slate-900 text-lg">
                Servicering og indregulering af ventilationsanlæg
              </p>
              <p>
                Med 25 års erfaring i ventilationsbranchen har K-TO Multiservice udført mange forskellige opgaver for erhvervskunder i Jylland og på Fyn, primært med udgangspunkt i service og indregulering af ventilationsanlæg samt opgaver vedrørende indeklima.
              </p>
              <p>
                I 25 år har K-TO Multiservice arbejdet med indregulering, service og fejlfinding af køle- og ventilationsanlæg.
              </p>
              <p>
                Hos K-TO Multiservice hjælper vi virksomheder med at sikre et godt indeklima gennem effektive ventilationsanlæg. Med mere end 25 års erfaring inden for service, indregulering og fejlfinding kan vi løse både små og store opgaver med fokus på driftssikre og holdbare løsninger.
              </p>
            </div>

            <div className="pt-2">
              <Link 
                to="/k-to-ventilationsteknik" 
                className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs uppercase tracking-wider px-6 py-3 rounded-xl transition-colors shadow"
              >
                <span>Læs mere om virksomheden</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=80,format=auto/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-7-1024x683.jpg" 
                alt="K-TO servicetekniker i arbejde"
                className="w-full h-[450px] lg:h-[550px] object-cover object-top"
              />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-slate-950/90 via-slate-950/60 to-transparent p-6 text-white">
                <span className="text-xs font-bold text-sky-400 uppercase tracking-wider block">
                  Personlig service
                </span>
                <p className="text-sm font-semibold text-slate-100">
                  Faguddannet servicetekniker med fokus på præcision og driftssikkerhed
                </p>
              </div>
            </div>
          </div>

        </div>
      </section>

      {/* Ydelser Section */}
      <section id="ydelser" className="relative bg-slate-950 text-white py-16 md:py-24 overflow-hidden border-y border-slate-800">
        {/* Full-bleed background image with heavy dark overlay */}
        <div className="absolute inset-0 z-0 opacity-20">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=80,format=auto/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-2-1024x683.jpg" 
            alt="Ventilationsanlæg og teknikrum" 
            className="w-full h-full object-cover" 
          />
          <div className="absolute inset-0 bg-slate-950/90 backdrop-blur-sm"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Top introductory text block left-aligned (~half container width) */}
          <div className="max-w-2xl space-y-3">
            <span className="text-sky-400 text-xs font-bold uppercase tracking-widest block">
              Vores kompetencer
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
              Specialiserede ydelser til erhverv og industri
            </h2>
            <p className="text-slate-300 text-base leading-relaxed">
              Vi leverer komplette løsninger inden for ventilation, køling og energioptimering med ensartede høje standarder.
            </p>
          </div>

          {/* Bottom feature grid with continuous thin borders & sharp zero-radius corners */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l border-slate-800 bg-slate-900/60 backdrop-blur-md">
            {SERVICES_LIST.map((service, index) => {
              const isLast = index === SERVICES_LIST.length - 1;
              return (
                <Link
                  key={service.slug}
                  to={`/ydelser/${service.slug}`}
                  className={`border-r border-b border-slate-800 p-8 flex flex-col justify-between items-center text-center group hover:bg-slate-800/80 transition-colors duration-200 ${
                    isLast ? 'sm:col-span-2 lg:col-span-3' : ''
                  }`}
                >
                  <div className="space-y-4 flex flex-col items-center">
                    <div className="text-3xl text-sky-400 group-hover:text-sky-300 transition-colors">
                      <i className={service.icon} aria-hidden="true"></i>
                    </div>
                    <h3 className="text-base font-extrabold uppercase tracking-wider text-white group-hover:text-sky-400 transition-colors">
                      {service.name}
                    </h3>
                    <p className="text-xs text-slate-400 leading-relaxed max-w-md">
                      {service.shortDesc}
                    </p>
                  </div>

                  <div className="pt-6 mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-sky-400 group-hover:text-sky-300">
                    <span>Læs mere</span>
                    <i className="fa-solid fa-arrow-right text-[10px] group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Erhverv og Industri Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
        <div className="max-w-3xl space-y-3">
          <span className="text-sky-600 text-xs font-bold uppercase tracking-widest block">
            Målgruppe & branchekendskab
          </span>
          <h2 className="text-3xl sm:text-4xl font-light text-slate-900 tracking-tight">
            Målrettede ventilationsløsninger til erhverv og industri
          </h2>
          <div className="w-16 h-0.5 bg-sky-600 my-4"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8">
          <div className="border-l-2 border-sky-600 pl-5 space-y-2">
            <span className="text-[11px] font-bold uppercase tracking-widest text-sky-600 block">
              01 / Produktion
            </span>
            <h3 className="text-base font-bold uppercase text-slate-900 tracking-wider">
              Produktionsvirksomheder
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Sikrer løbende udluftning, fjernelse af støv/damp og opretholdelse af stabile temperaturer i produktionshaller.
            </p>
          </div>

          <div className="border-l-2 border-sky-600 pl-5 space-y-2">
            <span className="text-[11px] font-bold uppercase tracking-widest text-sky-600 block">
              02 / Lager & Logistik
            </span>
            <h3 className="text-base font-bold uppercase text-slate-900 tracking-wider">
              Lagerbygninger
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Optimeret luftcirkulation og fugtkontrol til at beskytte råvarer, færdigvarer og medarbejdernes indeklima.
            </p>
          </div>

          <div className="border-l-2 border-sky-600 pl-5 space-y-2">
            <span className="text-[11px] font-bold uppercase tracking-widest text-sky-600 block">
              03 / Kontor & Administration
            </span>
            <h3 className="text-base font-bold uppercase text-slate-900 tracking-wider">
              Kontorer & Administration
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Støjsvage og velregulerede ventilationsanlæg, der skaber et friskt arbejdsmiljø med lavt CO2-niveau.
            </p>
          </div>

          <div className="border-l-2 border-sky-600 pl-5 space-y-2">
            <span className="text-[11px] font-bold uppercase tracking-widest text-sky-600 block">
              04 / Drift & Offentlig
            </span>
            <h3 className="text-base font-bold uppercase text-slate-900 tracking-wider">
              Ejendomsdrift & Institutioner
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed">
              Systematisk forebyggende service og indregulering for maksimal driftssikkerhed og energieffektivitet.
            </p>
          </div>
        </div>
      </section>

      {/* 30 Års Erfaring Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="relative bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-200/90 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center relative z-10">
            
            {/* Left column */}
            <div className="lg:col-span-6 space-y-6">
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-sky-100 text-sky-800 text-xs font-bold uppercase tracking-wider">
                <i className="fa-solid fa-award text-sky-600" aria-hidden="true"></i>
                <span>Tre årtiers erfaring</span>
              </div>

              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight">
                30 års erfaring med ventilationsteknik
              </h2>

              <p className="text-slate-600 text-base leading-relaxed">
                Vores tre årtiers praktiske erfaring er din garanti for, at opgaven bliver udført fagmæssigt korrekt første gang. Vi kender de specifikke udfordringer i ældre og nyere anlæg og sikrer altid den bedst mulige balancering, støjreducering og energieffektivitet.
              </p>

              <div className="pt-2">
                <Link
                  to="/kontakt"
                  className="bg-sky-600 hover:bg-sky-500 text-white px-7 py-4 rounded-xl font-extrabold text-xs uppercase tracking-wider transition-colors inline-flex items-center gap-2 shadow-md hover:shadow-sky-500/20"
                >
                  <span>Få et fagligt tilbud</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true"></i>
                </Link>
              </div>
            </div>

            {/* Right column with Image */}
            <div className="lg:col-span-6 relative pb-12 lg:pb-0">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
                <img 
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=80,format=auto/assets/379e2bd1-51e7-4436-a4bf-bf31d3b287e1/ventilationservice-8-1024x683.jpg" 
                  alt="Servicetekniker med 30 års erfaring"
                  className="w-full h-[360px] lg:h-[440px] object-cover"
                />
              </div>

              {/* Overlapping feature card positioned horizontally below main text content / partially covering lower left of image */}
              <div className="lg:absolute -bottom-6 -left-12 lg:max-w-lg bg-sky-900 text-white p-6 rounded-2xl shadow-2xl border border-sky-700 mt-6 lg:mt-0">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div className="space-y-1">
                    <div className="flex items-center gap-2 text-sky-300 font-bold text-sm">
                      <i className="fa-solid fa-shield-halved text-sky-400" aria-hidden="true"></i>
                      <h4 className="font-bold text-white text-xs uppercase tracking-wider">Fagmæssigt Korrekt</h4>
                    </div>
                    <p className="text-xs text-sky-100 leading-normal">
                      Grundig gennemgang og præcis udmåling ved hvert eftersyn.
                    </p>
                  </div>
                  <div className="space-y-1">
                    <div className="flex items-center gap-2 text-sky-300 font-bold text-sm">
                      <i className="fa-solid fa-clock-rotate-left text-sky-400" aria-hidden="true"></i>
                      <h4 className="font-bold text-white text-xs uppercase tracking-wider">Hurtig Udrykning</h4>
                    </div>
                    <p className="text-xs text-sky-100 leading-normal">
                      Kører i hele Jylland og på Fyn med kort responstid.
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>



      {/* Final CTA Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-slate-900 via-slate-900 to-sky-950 text-white rounded-3xl p-8 sm:p-12 text-center space-y-6 shadow-2xl border border-slate-800">
          <h2 className="text-2xl sm:text-4xl font-extrabold tracking-tight max-w-3xl mx-auto">
            Har virksomheden brug for service, fejlfinding eller en ny ventilationsløsning?
          </h2>
          <p className="text-slate-300 text-sm sm:text-base max-w-2xl mx-auto">
            Kontakt K-TO Ventilationsteknik i dag og få en uforpligtende samtale og et tilbud tilpasset jeres anlæg.
          </p>

          <div className="flex flex-wrap justify-center items-center gap-4 pt-2">
            <a
              href={`tel:${COMPANY_INFO.phoneRaw}`}
              className="bg-sky-600 hover:bg-sky-500 text-white px-7 py-4 rounded-xl font-extrabold text-xs uppercase tracking-wider transition-all shadow-lg hover:shadow-sky-500/30 flex items-center gap-2.5 nowrap-contact"
            >
              <i className="fa-solid fa-phone" aria-hidden="true"></i>
              <span>Ring på 22 72 87 23</span>
            </a>

            <a
              href={`mailto:${COMPANY_INFO.email}`}
              className="bg-slate-800 hover:bg-slate-700 text-white px-6 py-4 rounded-xl font-bold text-xs uppercase tracking-wider border border-slate-700 transition-colors flex items-center gap-2 nowrap-contact"
            >
              <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true"></i>
              <span>Skriv til k-to@outlook.dk</span>
            </a>

            <Link
              to="/kontakt"
              className="bg-white hover:bg-slate-100 text-slate-900 px-6 py-4 rounded-xl font-bold text-xs uppercase tracking-wider transition-colors flex items-center gap-2"
            >
              <i className="fa-solid fa-paper-plane text-slate-700" aria-hidden="true"></i>
              <span>Gå til kontakt</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
}
